import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";

export default function SupportPage() {
  const [formData, setFormData] = useState({ name: "", email: "", inquiry_type: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const form = e.currentTarget;
    const honeypot = form.elements.namedItem("phone_alt") as HTMLInputElement;
    if (honeypot && honeypot.value.trim()) {
      e.preventDefault();
      return;
    }
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: "", email: "", inquiry_type: "", message: "" });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      {/* Page Header */}
      <section className="bg-background-100 border-b border-background-300">
        <div className="max-w-[860px] mx-auto px-3 md:px-4 py-8 md:py-10">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-400 transition-colors mb-3"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </span>
            홈으로
          </Link>
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 flex items-center justify-center text-primary-500">
              <i className="ri-customer-service-2-line text-2xl" />
            </span>
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-foreground-700">고객센터</h1>
              <p className="text-sm text-foreground-600 mt-0.5">
                궁금하신 점이나 불편사항이 있으시면 언제든지 문의해주세요
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-[860px] mx-auto px-3 md:px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Contact Form */}
          <div className="bg-background-100 rounded-lg border border-background-300 p-5 md:p-6">
            <h2 className="text-base font-bold text-foreground-700 mb-4 flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className="ri-mail-send-line" />
              </span>
              1:1 문의하기
            </h2>
            {submitted ? (
              <div className="text-center py-8">
                <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-primary-500/10 flex items-center justify-center">
                  <span className="w-7 h-7 flex items-center justify-center text-primary-500">
                    <i className="ri-check-line text-2xl" />
                  </span>
                </div>
                <h3 className="text-base font-bold text-foreground-700 mb-1">문의가 접수되었습니다</h3>
                <p className="text-sm text-foreground-600 mb-4">빠른 시일 내에 답변드리겠습니다</p>
                <button
                  onClick={() => setSubmitted(false)}
                  className="px-4 py-2 text-sm bg-primary-500 text-foreground-50 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  새 문의 작성
                </button>
              </div>
            ) : (
              <form
                id="support-form"
                data-readdy-form
                action="https://readdy.ai/api/form/d92cn8nefssur58kquh0"
                method="POST"
                encType="application/x-www-form-urlencoded"
                className="space-y-4"
                onSubmit={handleSubmit}
              >
                <div>
                  <label className="block text-xs font-bold text-foreground-600 mb-1.5">이름</label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full bg-background-200 rounded-lg px-4 py-2.5 text-sm text-foreground-700 border border-background-300 focus:border-primary-500/50 outline-none transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-foreground-600 mb-1.5">이메일</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full bg-background-200 rounded-lg px-4 py-2.5 text-sm text-foreground-700 border border-background-300 focus:border-primary-500/50 outline-none transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-foreground-600 mb-1.5">문의 유형</label>
                  <select
                    name="inquiry_type"
                    value={formData.inquiry_type}
                    onChange={(e) => setFormData({ ...formData, inquiry_type: e.target.value })}
                    className="w-full bg-background-200 rounded-lg px-4 py-2.5 text-sm text-foreground-700 border border-background-300 focus:border-primary-500/50 outline-none transition-colors"
                  >
                    <option value="">선택해주세요</option>
                    <option value="general">일반 문의</option>
                    <option value="verification">먹튀 제보</option>
                    <option value="technical">기술 지원</option>
                    <option value="partnership">제휴 문의</option>
                    <option value="other">기타</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-bold text-foreground-600 mb-1.5">문의 내용</label>
                  <textarea
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full bg-background-200 rounded-lg px-4 py-2.5 text-sm text-foreground-700 border border-background-300 focus:border-primary-500/50 outline-none transition-colors resize-none"
                  />
                </div>

                <div className="hp-field">
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full py-2.5 bg-primary-500 text-foreground-50 text-sm font-bold rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  문의하기
                </button>
              </form>
            )}
          </div>

          {/* Info */}
          <div className="space-y-4">
            <div className="bg-background-100 rounded-lg border border-background-300 p-5 md:p-6">
              <h2 className="text-base font-bold text-foreground-700 mb-4 flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                  <i className="ri-links-line" />
                </span>
                빠른 링크
              </h2>
              <div className="space-y-2">
                <Link
                  to="/faq"
                  className="flex items-center gap-2 p-3 rounded-lg bg-background-200/50 hover:bg-background-200 transition-colors text-sm text-foreground-600 hover:text-foreground-700"
                >
                  <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-question-answer-line" />
                  </span>
                  자주 묻는 질문
                </Link>
                <Link
                  to="/notices"
                  className="flex items-center gap-2 p-3 rounded-lg bg-background-200/50 hover:bg-background-200 transition-colors text-sm text-foreground-600 hover:text-foreground-700"
                >
                  <span className="w-4 h-4 flex items-center justify-center text-secondary-500">
                    <i className="ri-megaphone-line" />
                  </span>
                  공지사항
                </Link>
                <Link
                  to="/verification"
                  className="flex items-center gap-2 p-3 rounded-lg bg-background-200/50 hover:bg-background-200 transition-colors text-sm text-foreground-600 hover:text-foreground-700"
                >
                  <span className="w-4 h-4 flex items-center justify-center text-red-400">
                    <i className="ri-alert-line" />
                  </span>
                  먹튀 제보하기
                </Link>
              </div>
            </div>

            <div className="bg-background-100 rounded-lg border border-background-300 p-5 md:p-6">
              <h2 className="text-base font-bold text-foreground-700 mb-4 flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                  <i className="ri-time-line" />
                </span>
                운영 시간
              </h2>
              <div className="space-y-3 text-sm text-foreground-600">
                <div className="flex items-center justify-between">
                  <span>실시간 채팅</span>
                  <span className="text-foreground-700 font-bold">평일 09:00 - 21:00</span>
                </div>
                <div className="flex items-center justify-between">
                  <span>전화 상담</span>
                  <span className="text-foreground-700 font-bold">평일 12:00 - 19:00</span>
                </div>
                <div className="flex items-center justify-between">
                  <span>이메일 문의</span>
                  <span className="text-foreground-700 font-bold">24시간 접수</span>
                </div>
                <div className="pt-3 border-t border-background-300 text-xs text-foreground-600">
                  주말 및 공휴일은 실시간 채팅만 제한적으로 운영됩니다
                </div>
              </div>
            </div>

            <div className="bg-background-100 rounded-lg border border-background-300 p-5 md:p-6">
              <h2 className="text-base font-bold text-foreground-700 mb-3 flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                  <i className="ri-mail-line" />
                </span>
                이메일
              </h2>
              <p className="text-sm text-foreground-600">support@wdctv24.com</p>
              <p className="text-xs text-foreground-600 mt-1">24시간 접수 가능하며, 영업일 기준 24시간 이내에 답변드립니다</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}